export type ROUTE_ID = (typeof ROUTE_IDS)[keyof typeof ROUTE_IDS];

export const ROUTE_IDS = {
  Accounts: "accounts",
  AccountsList: "accounts_list",
  AccountsNew: "accounts_new",
  Applications: "applications",
  ApplicationsInstalled: "applications_installed",
  ApplicationsUpload: "applications_upload",
  ApplicationsStore: "applications_store",
  AppVersions: "app_versions",
  AppVersionsList: "app_versions_list",
  AppVersionsNew: "app_versions_new",
  ConnectionAttempts: "connection_attempts",
  Devices: "devices",
  DevicesBulkEdit: "devices_bulk_edit",
  DevicesBulkRegister: "devices_bulk_register",
  DevicesDelete: "devices_delete",
  DevicesList: "devices_list",
  DevicesNew: "devices_new",
  DevicesUpgradeFirmware: "devices_upgrade_firmware",
  DevicesUpgradePlayers: "devices_upgrade_players",
  Diagnostics: "diagnostics",
  DiagnosticsAlerts: "diagnostics_alerts",
  DiagnosticsCreateAlert: "diagnostics_create_alert",
  DiagnosticsEvents: "diagnostics_events",
  DiagnosticsIncidents: "diagnostics_incidents",
  DiagnosticsUptimeReport: "diagnostics_uptime_report",
  Download: "download",
  HelpCenter: "help_center",
  Networks: "networks",
  NetworksList: "networks_list",
  NetworksNew: "networks_new",
  Overview: "overview",
  PlayerReleaseManagement: "player_release_management",
  PlayerReleaseManagementConduct: "player_release_management_conduct",
  PlayerReleaseManagementDeviceDistribution:
    "player_release_management_device_distribution",
  PlayerReleaseManagementHistory: "player_release_management_history",
  Reports: "reports",
  ReportsAccountDevices: "reports_account_devices",
  ReportsActiveDevices: "reports_active_devices",
  ReportsOverview: "reports_overview",
  Strategies: "strategies",
  StrategiesDeploy: "strategies_deploy",
  StrategiesList: "strategies_list",
  StrategiesMediaLibrary: "strategies_media_library",
  StrategiesNew: "strategies_new",
  StrategiesPast: "strategies_past",
  StrategiesScheduled: "strategies_scheduled",
  Users: "users",
  UsersAccounts: "users_accounts",
  UsersList: "users_list",
  UsersNew: "users_new",
  UsersSystem: "users_system",
  WatchdogVersions: "watchdog_versions",
  WatchdogVersionsList: "watchdog_versions_list",
  WatchdogVersionsNew: "watchdog_versions_new",
} as const;
